import * as dataSourceExports from "@mecatran/datasource";
import { StopHaversineDistance, StopHaversineDistanceOptions } from "../transformers/stophaversinedistance.mjs";
import {StopSort} from "../transformers/stop.sort.mjs";
import {StopFilter} from "../transformers/stop.filter.mjs";
import {LimitFilter} from "../transformers/limit.filter.mjs";
var { DataLoader, DataSource } = dataSourceExports;

export class StopSource{
    constructor(indexSource, name, transforms){
        if (!(indexSource && transforms)) throw new Error('StopSource should provide parameters')
        //var stopSourceOptions = stopSourceOptions || {};
        this.initStopSource(indexSource, name, transforms);
    }
    // ==========
    // private
    // ----------

    setName(n){ this.name = n }

    getName(){ return this.name }

    setDataSource(dataSource){ this.dataSource = dataSource }
    
    getDataSource(){ return this.dataSource }
    
    setStopHaversineDistanceTransform(t){ this.stopHaversineDistanceTransform = t }

    getStopHaversineDistanceTransform(){ return this.stopHaversineDistanceTransform }

    setStopFilter(f){ this.stopFilter = f }

    getStopFilter(){ return this.stopFilter }

    setLimitFilter(f){ this.limitFilter = f }

    getLimitFilter(){ return this.limitFilter }

    createDataLoader(indexSource, dataLoaderOptions){
        return new IndexLoader(indexSource, dataLoaderOptions);
    }

    initDataSource(indexSource){
        var dataLoaderOptions = { cache : true }
        var dataLoader = this.createDataLoader(indexSource, dataLoaderOptions);
        var dataSourceOptions =  { }
        var dataSource = new DataSource(dataSourceOptions);
        dataSource.setName('stop-source')
        dataSource.setLoader(dataLoader);
        this.setDataSource(dataSource);
        dataSource.init();
    }

    createStopHaversineDistanceTransform(...center){
        return new StopHaversineDistance(...center)
    }

    addStopHaversineDistanceTransformer(center){
        var center = center || undefined;
        //if (!center) throw new Error('stopHaversineDistanceTransformer: center is mandatory')
        var transformer = this.getDataSource().getTransformer();
        var stopHaversineDistance = new StopHaversineDistance(center);
        this.setStopHaversineDistanceTransform(stopHaversineDistance);
        transformer.add(stopHaversineDistance.compute.bind(stopHaversineDistance));
    }

    addTransformers(transforms){
        var transformer = this.getDataSource().getTransformer();
        /* transformer 0 */
        transforms.forEach(transformFn => { transformer.add(transformFn)})



        /* transformer 1 */
        this.addStopHaversineDistanceTransformer(); 

        /* transformer 2 */
        var stopSort = new StopSort();
        transformer.add(stopSort.sort.bind(stopSort))
        

        /* transformer 3 */
        var stopFilter = new StopFilter();
        stopFilter.setQueriableProperties(['name','city'])
        this.setStopFilter(stopFilter);
        transformer.add(stopFilter.filter.bind(stopFilter));

        /* transformer 4 */
        var limitFilter = new LimitFilter();
        this.setLimitFilter(limitFilter);
        transformer.add(limitFilter.filter.bind(limitFilter))
        
    }

    initStopSource(indexSource, name, transforms){
        this.setName(name);
        this.initDataSource(indexSource);
        this.addTransformers(transforms);
    }

    // ==========
    // public
    // ----------
    get(){ 
        var dataSource = this.getDataSource()
        return dataSource.get(); 
    }
    
    setCenter(lat, lon){
        this.getStopHaversineDistanceTransform().setCenter(lat,lon);
     }

    setQuery(query){
        this.getStopFilter().setQuery(query);
    }

    clearCache(){
        this.getDataSource().getDataLoader().clearCache();
    }
}



class IndexLoader extends DataLoader{
    constructor(indexSource, dataLoaderOptions){
        super(dataLoaderOptions);
        if (!indexSource) throw new Error('IndexLoader. indexSource is mandatory')
        this.indexSource = indexSource;
    }
    // ==========
    // private
    // ---------
    getIndexSource(){ return this.indexSource }

    // ==========
    // overload 
    // ---------
    load(){
        return this.getIndexSource().get();
    }
}

/**
 * StopSourceOptions extends DataSourceOptions
 */